"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("styled-components");
// ATOMS
var Styles_1 = require("./Container/Styles");
var Styles_2 = require("./Input/Button/Styles");
var Styles_3 = require("./Input/FilePickerButton/Styles");
var Styles_4 = require("./Input/Form/Styles");
var Styles_5 = require("./Input/TextInput/Styles");
var Styles_6 = require("./Input/TextAreaInput/Styles");
var Styles_7 = require("./Input/Switch/Styles");
var Styles_8 = require("./Word/Styles");
var Styles_9 = require("./Loader/Styles");
var Styles_10 = require("./AppLogo/Styles");
var Styles_11 = require("./Input/Radio/Styles");
var Styles_12 = require("./Input/Checkbox/Styles");
var Styles_13 = require("./Input/MagnifiyingGlassCheckBox/Styles");
// ICONS
var common_1 = require("../Icons/common");
exports.default = styled_components_1.createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n"], ["\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n"])), Styles_1.ContainerStyles, Styles_2.StylesButton, Styles_3.StylesFilePickerButton, Styles_4.StylesForm, Styles_5.StylesTextInput, Styles_6.StylesTextAreaInput, Styles_7.StylesSwitch, Styles_8.StylesWord, Styles_9.LoaderStyles, Styles_10.StylesAppLogo, Styles_11.StylesRadio, common_1.StylesIcons, Styles_12.StylesCheckbox, Styles_13.StylesMagnifyingGlassCheckbox);
var templateObject_1;
